import { forwardRef, type InputHTMLAttributes } from "react";
import { Input } from "@/components/ui/input";
import { formatRupiahDigits, parseRupiahInput } from "@/lib/format";

export interface RupiahInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "value" | "onChange"> {
  value: number | undefined;
  onChange: (value: number | undefined) => void;
  inputSize?: "sm" | "md";
}

/** Rupiah amount: formatted with thousand separators while typing, emitted as an integer. */
export const RupiahInput = forwardRef<HTMLInputElement, RupiahInputProps>(function RupiahInput({ value, onChange, inputSize, ...props }, ref) {
  return (
    <Input
      ref={ref}
      inputMode="numeric"
      autoComplete="off"
      inputSize={inputSize}
      leading={<span className="text-sm font-semibold text-slate-500">Rp</span>}
      value={formatRupiahDigits(value)}
      onChange={(e) => onChange(parseRupiahInput(e.target.value))}
      {...props}
    />
  );
});
